import Modal from "@/components/modal";
import EnterCodeWidget from "@/widgets/enter-code.widget";
import { t } from "i18next";
import Space from "@/components/space";

interface Props {
  isOpen: boolean;
  name?: string;
  status: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function OrganizationDeleteModal({
  isOpen,
  name,
  status,
  onCancel,
  onConfirm,
}: Props) {
  if (!isOpen) return null;

  return (
    <Modal onClose={onCancel} title={`Supprimer organisation “${name}”`}>
      <div className="space-y-4 text-neutral-800">
        <p>
          <b>
            {t("Cette action archivera définitivement l'organisation")}
            <span className="mx-1">“{name}”</span>
            {t("ainsi que l'ensemble de ses données associées.")}
          </b>
        </p>

        <p className="text-sm red-t">{t("Cette action est irréversible.")}</p>

        <Space />

        <EnterCodeWidget
          onCancel={onCancel}
          onNext={onConfirm}
          status={status}
        />
      </div>
    </Modal>
  );
}
